import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";

const ViewSellerLayout = () => {
  const id = localStorage.getItem("id");
  return (
    <>
      <div className="mb-20 w-[80vw]">
        <div className="border-b border-gray-300 py-7">
          <h1 className="md:text-2xl lg:text-3xl max-lg:text-4xl font-semibold text-[#667085]">
            Seller
          </h1>
        </div>
        <div className="mt-10">
          <h1 className="md:text-mg lg:text-lg w-fit max-lg:text-xl flex justify-start items-center cursor-pointer font-semibold text-[#667085]">
            <NavLink className={"flex justify-start items-center"} to={"/admin-dashboard/productsellers"}>
              <IoIosArrowBack /> Home
            </NavLink>
          </h1>
        </div>
        <div className="flex w-full justify-between pt-5 pb-10  ">
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex items-center gap-2 text-blood text-base font-medium border-b-[3px] border-blood"
                : "flex items-center gap-2 text-[#667085] text-base font-medium"
            }
            to={`seller-details`}
          >
            Seller Details
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex items-center gap-2 text-blood text-base font-medium border-b-[3px] border-blood"
                : "flex items-center gap-2 text-[#667085] text-base font-medium"
            }
            to={"purschase"}
          >
            {" "}
            Purchased Leads
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex items-center gap-2 text-blood text-base font-medium border-b-[3px] border-blood "
                : "flex items-center gap-2 text-[#667085] text-base font-medium"
            }
            to={"subscriptionplan"}
          >
            {" "}
            Subscription Plan
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex items-center gap-2 text-blood text-base font-medium border-b-[3px] border-blood "
                : "flex items-center gap-2 text-[#667085] text-base font-medium"
            }
            to={"purschasehistories"}
          >
            Purchase History
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex items-center gap-2 text-blood text-base font-medium border-b-[3px] border-blood "
                : "flex items-center gap-2 text-[#667085] text-base font-medium"
            }
            to={"reviewratings"}
          >
            Review and Ratings
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex items-center gap-2 text-blood text-base font-medium border-b-[3px] border-blood "
                : "flex items-center gap-2 text-[#667085] text-base font-medium"
            }
            to={"rfqs"}
          >
            RFQ's & Quotes
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex items-center gap-2 text-blood text-base font-medium border-b-[3px] border-blood"
                : "flex items-center gap-2 text-[#667085] text-base font-medium"
            }
            to={"commmunication"}
          >
            Communication History
          </NavLink>
        </div>
        <div>
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default ViewSellerLayout;
